import React, { useState } from 'react';
import CreatableSelect, { CreatableProps } from 'react-select/creatable';
import { GroupBase } from 'react-select';
import { Button } from 'react-bootstrap';

interface CustomCreatableSelectProps
  extends Omit<
    CreatableProps<string, boolean, GroupBase<string>>,
    'onChange' | 'options'
  > {
  containerClassName?: string;
  onChange: (value: string[]) => void;
  options: string[];
}

const CustomContainerCreatableSelect = ({
  options,
  onChange,
  containerClassName,
  ...props
}: CustomCreatableSelectProps) => {
  const [selectedOptions, setSelectedOptions] =
    useState<readonly string[]>(options);

  const handleCreateOption = (inputValue: string) => {
    const optionSet = new Set([inputValue, ...selectedOptions]);
    setSelectedOptions(Array.from(optionSet));
    onChange(Array.from(optionSet));
  };

  const handleRemoveOption = (value: string): void => {
    const updatedOptions = selectedOptions.filter((option) => option !== value);
    setSelectedOptions(updatedOptions);
    onChange?.(updatedOptions);
  };

  return (
    <div>
      <CreatableSelect
        {...props}
        isMulti
        controlShouldRenderValue={false}
        value={selectedOptions}
        onCreateOption={handleCreateOption}
      />
      <div className={containerClassName}>
        {selectedOptions.map((option) => (
          <div key={option}>
            <span>
              {option}
              <Button variant="link" onClick={() => handleRemoveOption(option)}>
                {' '}
                {'\u2715'}{' '}
              </Button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomContainerCreatableSelect;
